class Hamburger {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Listen for toggling from the hamburger icon
        $('.navbar-toggler.hamburger').on('click', function () {
            $(this).toggleClass('is-active');
        });

    }
}

export default Hamburger;